<template>

  <div class='top-bar'>
    <button class="left" data-cmd="backToDos"></button>
    <button class="right" data-cmd="toggleZoom"></button>
    <h2><label>{{ title }}</label></h2>
  </div>

</template>
<style lang="scss">

  .top-bar {

    background-color: #000;
    height: 14px;
    box-sizing: content-box;
    border: 1px solid #000;
    border-width: 1px 0;

    overflow: hidden;

    // left and right white and black buttons
    button {
      width: 13px;
      box-sizing: content-box;
      min-width: 13px;
      border: none;
      background-repeat: no-repeat;

      &:first-of-type {
        border-right: 1px solid #000;
        background-image: url(../assets/handle.gif);
        background-position: 2px 2px;
      }

      &:last-of-type {
        border-left: 1px solid #000;
        background-image: url(../assets/corner.gif);
        background-position: 0 0;
      }
    }

    h2 {
      margin: 0;
      text-align: center;

      label {
        margin: 0 auto;
        padding: 0 1px;
        background-color: #000;
        color: #fff;
      }
    }
  }

</style>


<script>

  import config from '../data/config';
  import state from '../data/state';

  export default{
    props: ['title'],
    data(){
      return {
        config,
        state
      }
    }
  }

</script>



// WEBPACK FOOTER //
// WinHeader.vue?3b771795